import request from './index'

export const login = (username, password) => 
  request.post('/api/user/login', { username, password })